import {useEffect, useRef} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {parseOAuthCallback} from '@/services/google';
import {useUserStore} from '@/store';
import styles from './OAuthCallback.module.css';

export function OAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {signInWithGoogle, linkGoogleEmail, isAuthenticated, authError} = useUserStore();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const {code, state} = parseOAuthCallback(searchParams.toString());

    if (!code) {
      // No code — redirect back to onboarding
      navigate('/onboarding', {replace: true});
      return;
    }

    if (state === 'email-sync') {
      // User is linking Gmail for email sync
      linkGoogleEmail(code).then(() => {
        navigate('/onboarding/syncing', {replace: true});
      });
    } else {
      // Default: sign in with Google
      signInWithGoogle(code).then(() => {
        const store = useUserStore.getState();
        if (store.isAuthenticated) {
          // Authenticated user — go to connect email step
          navigate('/onboarding/connect-email', {replace: true});
        }
      });
    }
  }, [searchParams, signInWithGoogle, linkGoogleEmail, navigate]);

  // Show error if auth failed
  if (authError) {
    return (
      <div className={styles.overlay}>
        <div className={styles.inner}>
          <div className={styles.logo}>Closai</div>
          <p className={styles.error}>{authError}</p>
          <button
            className={styles.retryBtn}
            onClick={() => navigate('/onboarding', {replace: true})}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.inner}>
        <div className={styles.logo}>Closai</div>
        <div className={styles.spinner} />
        <p className={styles.text}>
          {isAuthenticated ? 'Connecting your email...' : 'Signing you in...'}
        </p>
      </div>
    </div>
  );
}
